// extracted by mini-css-extract-plugin
module.exports = {"youtubeWrapper":"finance-explained_youtubeWrapper__rS3Wk","youtubeWrapperTitle":"finance-explained_youtubeWrapperTitle__ZOZa8"};